export default __webpack_public_path__ + "../staticImages/recurring-order-dummy.jpg";